import { Dispatch } from "react";
import { ThunkAction } from "redux-thunk";
import * as AuthenticationService from '../../../lib/Authentication/AuthenticationService';
import { OktaToken } from "../../../lib/Authentication/interfaces/OktaAuth";
import * as AppCreators from '../../../redux/creators/AppCreators';
import * as LoginCreators from '../../../redux/creators/LoginCreators';
import { FormState } from "../../../redux/interfaces/common/FormState";
import { LoginFormFields } from "../../../redux/interfaces/LoginState";
import StoreState from "../../../redux/interfaces/StoreState";

export function onCheckAuthentication(): ThunkAction<void, StoreState, void, any> {
  return async (dispatch: Dispatch<any>, getState: () => StoreState) => {

    const authenticationToken: OktaToken | null = await AuthenticationService.CheckAuthentication();

    dispatch(AppCreators.SetAuthenticationToken(authenticationToken));

    if (authenticationToken != null) {
      window.location.href = '/dashboard';
    }
  }
}

/**
 * Sign in with username and password using loginWithCredentials (Okta Auth API + getWithoutPrompt).
 * On success: set token and redirect to dashboard. On failure: show form error and stop loader.
 */
export function onLogin(): ThunkAction<void, StoreState, void, any> {
  return async (dispatch: Dispatch<any>, getState: () => StoreState) => {
    const loginFormState: FormState<LoginFormFields> = getState().Login.loginForm;
    dispatch(LoginCreators.SetFormLoading(loginFormState.id, true));
    dispatch(LoginCreators.ClearFormError(loginFormState.id));

    const rawUsername = loginFormState.fields.username?.value;
    const rawPassword = loginFormState.fields.password?.value;
    const username = typeof rawUsername === 'string' ? rawUsername.trim() : '';
    const password = typeof rawPassword === 'string' ? rawPassword : '';

    if (!username || !password) {
      dispatch(LoginCreators.SetFormLoading(loginFormState.id, false));
      dispatch(LoginCreators.SetFormError(loginFormState.id, true));
      dispatch(LoginCreators.SetFormErrorMessages(loginFormState.id, ['Please enter username and password.']));
      return;
    }

    try {
      const authenticationToken: OktaToken | null = await AuthenticationService.loginWithCredentials(username, password);

      dispatch(LoginCreators.SetFormLoading(loginFormState.id, false));

      if (authenticationToken != null) {
        dispatch(AppCreators.SetAuthenticationToken(authenticationToken));
        return;
      }

      dispatch(LoginCreators.SetFormError(loginFormState.id, true));
      dispatch(LoginCreators.SetFormErrorMessages(loginFormState.id, ['Your login attempt failed.']));
    } catch (_err) {
      dispatch(LoginCreators.SetFormLoading(loginFormState.id, false));
      dispatch(LoginCreators.SetFormError(loginFormState.id, true));
      const message = _err instanceof Error ? _err.message : 'Your login attempt failed.';
      dispatch(LoginCreators.SetFormErrorMessages(loginFormState.id, [message]));
    }
  }
}
